import {createStore} from 'vuex'
import axiosApi from "@/utils/axiosApi";
import {_message, LoginAccountValue} from "@/utils/func";
import router from "@/router";

export default createStore({
    state: {
        storeInfo: {},
        userInfo: {},
        userAddress: {}
    },
    getters: {},
    mutations: {
        getStoreInfo(state, playload) {
            if (!playload) {
                let stores = window.sessionStorage.getItem("storeInfo");
                if (!stores) {
                    this.state.storeInfo = {}
                } else {
                    this.state.storeInfo = JSON.parse(stores)
                }
            } else {
                window.sessionStorage.setItem("storeInfo", JSON.stringify(playload))
                this.state.storeInfo = playload
            }
        },
        getUserInfo(state, playload) {
            if (!playload) {
                let user = window.sessionStorage.getItem("userInfo");
                if (!user) {
                    this.state.userInfo = {}
                } else {
                    this.state.userInfo = JSON.parse(user)
                }
            } else {
                window.sessionStorage.setItem("userInfo", JSON.stringify(playload))
                this.state.userInfo = playload
            }
        },
        removeUserInfo(state) {
            window.sessionStorage.removeItem("userInfo");
            this.state.userInfo = {}
        },
        removeStoreInfo(state) {
            window.sessionStorage.removeItem("storeInfo");
            this.state.storeInfo = {}
        },
        updateUserInfo(state) {
            let userIts = window.sessionStorage.getItem("userInfo")
            if (!userIts) {
                this.state.userInfo = {};
                return;
            }
            userIts = JSON.parse(userIts)
            //更新账户信息
            let method = "";
            let encode = "site"
            let body = {};
            let xiam = window.sessionStorage.getItem("xm_air_logini_params");
            switch (userIts.accountType) {
                case "scal":
                    method = "user/check_login";
                    body = {
                        cust_id: userIts.cust_id,
                        token: userIts.token
                    }
                    break;
                case "xm_air":
                    xiam = JSON.parse(xiam)
                    method = "user/xm_user_info"
                    body = xiam
                    break;
                case "cmcc":
                    encode = "site";
                    method = "cmcc/scoreQuery"
                    body = {
                        mobile: userIts.phoneNumber,
                        type: "score"
                    }
                    break;
            }
            //获取会员信息
            new axiosApi({
                encode,
                method,
                body
            }).send((res) => {
                if (res.message.code !== "000") {
                    return _message("error", "登录信息已过期！", 3000, () => {
                        window.sessionStorage.removeItem("userInfo");
                        this.state.userInfo = {}
                        router.replace({name: 'login', params: userIts.accountType})
                    })
                }
                const _data = LoginAccountValue(userIts.accountType, res.data)
                window.sessionStorage.setItem("userInfo", JSON.stringify(_data))
                this.state.userInfo = _data
            }, () => {
                _message("error", "登录信息已过期！", 3000, () => {
                    window.sessionStorage.removeItem("userInfo");
                    this.state.userInfo = {}
                    router.replace({name: 'login', params: userIts.accountType})
                })
            })
        },
        getUserAddress(state, playload) {
            if (playload) {
                window.sessionStorage.setItem("userAddress", JSON.stringify(playload))
                this.state.userAddress = playload
            } else {
                const address = window.sessionStorage.getItem("userAddress")
                this.state.userAddress = address ? JSON.parse(address) : {}
            }
        }
    },
    actions: {},
    modules: {}
})
